import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivityLogService } from 'src/app/shared/services/activity-logs-service/activity-logs.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-api-logs',
  templateUrl: './api-logs.component.html',
  styleUrls: ['./api-logs.component.css'],
})
export class ApiLogsComponent {
  pagination = {
    limit: 10,
    currentPage: 1,
    userId: '',
    searchText: '',
    fromDate: '',
    toDate: '',
    // typeId: ''
  };
  totalPage: number = 0;
  totalRecords: any;
  apiLogsData: any;
  id = '';
  searchForm!: FormGroup;

  constructor(
    private apiLogService: ActivityLogService,
    private toastrMsgService: ToastrMsgService,
    private fb: FormBuilder
  ) {}
  callbackLogsTable = [
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
    {
      id: 1,
      transactionId: '10000',
      date: '01/01/2001',
    },
  ];
  currentDate = new Date();

  cValue = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
  ngOnInit() {
    // this.getAllLogs(this.pagination);
    this.initForm();
  }

  initForm() {
    this.searchForm = this.fb.group({
      searchText: [''],
      fromDate: new FormControl(new Date().toISOString().substring(0, 10)),
      toDate: new FormControl(new Date().toISOString().substring(0, 10)),

      // typeId: ['']
    });
  }

  nextPage() {
    this.pagination.currentPage++;
    this.getAllLogs(this.pagination);
  }

  onPageChange(page: any) {
    this.pagination.currentPage = page;
    this.getAllLogs(this.pagination);
  }

  previousPage() {
    if (this.pagination.currentPage > 1) {
      this.pagination.currentPage--;
      this.getAllLogs(this.pagination);
    }
  }
  onLast() {
    this.pagination.currentPage = this.totalPage;
    this.getAllLogs(this.pagination);
  }
  onFirst() {
    this.pagination.currentPage = 1;
    this.getAllLogs(this.pagination);
  }

  getAllLogs(pagination: any) {
    this.apiLogService.getAPIactivityLogs(pagination).subscribe({
      next: (response: any) => {
        console.log('Get All api logs ', response.data);
        this.apiLogsData = response.data.data;
        this.totalPage = response.data.totalPage;
        this.totalRecords = response.data.totalData;
      },
      error: (error) => {
        console.error('Error  getting state:', error);
      },
      complete: () => {
        console.log('Get request completed');
        // clean-up logic for this
      },
    });
  }

  searchApiLogs() {
    console.log(this.searchForm);
    let payload: any = {};
    payload = Object.assign({}, this.searchForm.value);
    payload.currentPage = this.pagination.currentPage;
    payload.limit = this.pagination.limit;
    this.getAllLogs(payload);
  }
}
